export default "__VITE_ASSET__mQD7jo8P__"